import { Component, Inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogClose, MatDialogModule } from '@angular/material/dialog';
import { RefundPublic } from '../../../../globalTypes/refund.types';
import { ButtonComponent } from '../../component/layout/element/button.component';
import { DatePipe } from '@angular/common';

export interface FaultyClaimData {
  refund: RefundPublic
}
export interface FaultyClaimResponse {
  response: 'accept' | 'reject'
  messageToBuyer?: string
}

@Component({
  selector: 'msh-faulty-claim-dialog',
  imports: [FormsModule, MatDialogClose, MatDialogModule, DatePipe, ButtonComponent],
  template: `
   <div class=" text-copy min-w-[50vw]">
    <div class=" p-8">
      @if(!data.refund.acceptedAsFaulty && !data.refund.rejectedAsFaulty){
        <div class="mb-2">Please respond to the buyer's claim.</div>
        <div class="rounded my-4 p-4 bg-copy/10">
          @for(interaction of data.refund.interactions_on_refund; track interaction.id){
            @if(interaction.isInitial){
              <div class=" font-thin mb-3">
                <div class="">
                  <span class=" font-normal"> {{interaction.subject}}</span>
                  @if(interaction.createdAt){
                    <span class=" opacity-50"> - {{interaction.createdAt | date:'short'}} </span> 
                  }
                </div>
                <div class="ml-10">{{interaction.body}}</div>
              </div>
            }
          }
        </div>
        <div class="text-sm">Accepting the claim means that you accept the shipping costs as a debt on your account. If you reject the claim, admin will make the final decision before the refund can be processed.  If it is decided that claim was false, the buyer will have the shipping removed from their refund amount.</div>
        <div class="my-4">
          <textarea id="messageToBuyer" placeholder="Message to Buyer (optional)" [(ngModel)]="messageToBuyer" rows="3" class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"></textarea>
        </div>
        <div class="flex justify-center gap-2">
          <msh-button cta="Accept" [mat-dialog-close]="{response: 'accept', messageToBuyer: messageToBuyer}"></msh-button>
          <msh-button cta="Reject" [mat-dialog-close]="{response: 'reject', messageToBuyer: messageToBuyer}"></msh-button>
        </div>
      }
    </div>
  <div class="bg-copy/10 flex justify-between py-4 px-6 gap-3">
      <button mat-flat-button [mat-dialog-close]="false">Close</button>
  </div>
   </div>
  `,
  styles: ``
})
export class FaultyClaimDialogComponent {

  messageToBuyer: string = '';

  constructor(
    public dialogRef: MatDialogRef<FaultyClaimDialogComponent>, 
    @Inject(MAT_DIALOG_DATA) public data: FaultyClaimData
  ){}
}
